import { Selector } from '@ngxs/store';
import { UserLocationState, UserLocationStateModel } from './user-location.state';
import { GeoPosition } from '../../locations/domains/geo-position';
import { GeoLocality } from '../../locations/domains/geo-locality';

export class UserLocationSelector {
  @Selector([UserLocationState])
  /** Absent until the person grants the permission and the geocoder answers. */
  static locality(state: UserLocationStateModel): GeoLocality | undefined {
    return state.locality;
  }

  @Selector([UserLocationState])
  /** Same: nothing is geocoded before a position is known. */
  static geoResult(state: UserLocationStateModel): google.maps.GeocoderResult | undefined {
    return state.geoResult;
  }

  @Selector([UserLocationState])
  /** Same: no coordinates until the permission is granted. */
  static position(state: UserLocationStateModel): GeoPosition | undefined {
    return state.coordinates;
  }

  @Selector([UserLocationState])
  static haveRoute(state: UserLocationStateModel): boolean {
    return !!state.nextRoute;
  }

  @Selector([UserLocationState])
  static routeTo(state: UserLocationStateModel): string {
    return state.nextRoute;
  }
}
